<template>
  <div class="pp-checkbox advanced-cookie-dialogue-input-checkbox">
    <input
      type="checkbox"
      :id="id"
      :name="name"
      class="advanced-cookie-dialogue-input-checkbox__input"
      :disabled="disabled"
      :checked="modelValue"
      @change="$emit('update:modelValue', $event.target.checked)"
    />
    <label :for="id" class="advanced-cookie-dialogue-input-checkbox__label">{{
      label
    }}</label>
    <p
      v-if="description"
      class="advanced-cookie-dialogue-input-checkbox__description"
    >
      {{ description }}
    </p>
  </div>
</template>

<script>
export default {
  name: "InputCheckbox",
  props: {
    id: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    modelValue: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    description: {
      type: String,
      deafault: false
    }
  },
  emits: ["update"]
};
</script>

<style lang="scss">
.advanced-cookie-dialogue-input-checkbox {
  &__input:disabled ~ &__label::before {
    color: grey;
  }

  &__description {
    margin: 2.5rem 0;
  }
}
</style>
